import React from 'react';
import './HomeAbout.css';

const HomeAbout = () => {
  return (
    <section className="home-about" id="about">
      <div className="home-about__inner">
        <div className="home-about__layout">
          
          <div className="home-about__left">
            <div className="home-about__header">
              <h2 className="home-about__title">Über uns</h2>
              <div className="home-about__slogan">
                <span className="home-about__slogan-word">Strategisch.</span>
                <span className="home-about__slogan-word">Unternehmerisch.</span>
                <span className="home-about__slogan-word">Persönlich.</span>
              </div>
            </div>
            
            <div className="home-about__intro">
    
              <p>
                Nintschew & Partner ist eine eigentümergeführte Boutique-Steuerberatungskanzlei 
                mit Sitz in Wien, die Steuerberatung seit 2022 neu lebt: strategisch ausgerichtet, unternehmerisch denkend, persönlich und klar in der Zusammenarbeit.
              </p>
            </div>
          </div>

          <div className="home-about__right">
            <div className="home-about__story">
              <div className="home-about__story-text">
                <p>
                  Wir betreuen ausgewählte mittelständische Unternehmen, Beteiligungsgesellschaften und Investoren aus unterschiedlichen Branchen. 
                  Unser Schwerpunkt liegt auf der <strong>Strategie- und Gestaltungsberatung</strong> sowie der ganzheitlichen <strong>Abgabenoptimierung</strong> – mit dem Ziel, 
                  Unternehmenswachstum zu fördern und Vermögen nachhaltig aufzubauen.
                </p>
                <p>
                  Als <strong>Sparringpartner</strong> auf Augenhöhe verbinden wir fachliche Expertise mit unternehmerischem Verständnis und Pragmatismus. 
                  Unsere Mandanten schätzen unseren proaktiven und gestalterischen Ansatz sowie die individuelle Betreuung mit persönlicher Verlässlichkeit.                </p>
                <p>
                  Unser agiles Team arbeitet effizient, lösungsorientiert und mit einem klaren Blick auf das Wesentliche – <strong>den Erfolg unserer Klienten</strong>.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </section>
  );
};

export default HomeAbout;


